import React, { useContext } from 'react';
import { Container } from '@pwskills/rachnaui';
import CategoryPageContext from '@/context/CategoryPageContext';
import SectionTitle from '@/components/common/SectionTitle';
import MentorCards from '../../HomePageRevamp/Mentors/MentorCards';

const MentorsSection = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const mentors = categoryDetails?.mentors || [];

  return (
    <div>
      {mentors && mentors?.length > 0 && (
        <section id="mentors" data-title="Mentors" className="">
          <Container className="medium:!px-8 large:!px-20  py-8 medium:py-14 ">
            <div className="flex flex-col gap-6 medium:gap-9">
              <SectionTitle
                upperText="Meet Your"
                lowerText="Instructors who are here to Make this Possible"
              />

              <div className="flex gap-6">
                {mentors && (
                  <MentorCards
                    instructors={mentors}
                    isLinkedInButtonEnabled
                    industryExpToBeShown
                    learnersPlacedToBeShown
                    isSocialIconEnabled
                  />
                )}
              </div>
            </div>
          </Container>
        </section>
      )}
    </div>
  );
};

export default MentorsSection;
